import { configAtom } from "@/config.ts";
import { allAssignedVmsQueryAtom } from "@/modules/compute/joinAssignedQuery.ts";
import { notifyError } from "@/modules/error/errorReporting.ts";
import { networkListQueryAtom } from "@/modules/network/networkListQuery.ts";
import { storageAccountListQueryWithPricesAtom } from "@/modules/storage/account/storageAccountQuery.ts";
import { PreloadAtom } from "@/utils/jotai/PreloadAtom.tsx";
import { atom } from "jotai/vanilla";

/** Prefetch query result atoms used by sidebar sections (for faster navigation) */
const prefetchAtom = atom((get) => {
    try {
        const config = get(configAtom);

        if (config.storageEnabled) get(storageAccountListQueryWithPricesAtom);
        if (config.vmsEnabled) get(allAssignedVmsQueryAtom);
        if (config.ipsEnabled) get(networkListQueryAtom);
    } catch (e) {
        console.warn("Error in prefetch", e);
        notifyError(e, { tags: ["prefetchAtom"] });
    }
});

export default function QueryPrefetch() {
    return <PreloadAtom atom={prefetchAtom} />;
}
